import { styled } from '@mui/material/styles';
import React, { useContext } from 'react';
import { TenantContext } from 'shared/contexts';

export default function TenantLogoType() {
    const { tenant } = useContext(TenantContext);

    if (!tenant?.logoTypeUri) {
        return null;
    }

    return (
        <Logo src={ tenant.logoTypeUri }
            alt="logo" />
    );
}

const Logo = styled('img')(({ theme }) => ({
    height: 24,
    width: 'auto',
  
    [theme.breakpoints.down('sm')]: {
        height: 28
    }
}));
